
import { ADD_CATEGORY, CATEGORY, COMPANYPROFILESETUP, DETAILPROFILE, GETPROFILESETUP, HOME_PAGE_GET_CATEGORY, PROFILEDETAIL, PROFILE_CATEGORY, REMOVEPROFILEIMAGE, RESUBMITPROFILE, SERVICES, UPDATECOMPANYPROFILE, UPDATEPROFILE } from "../Constants/ProfileConstants";
import { createGetDataReducer } from "./CommonReducer";

const CategoryReducer = createGetDataReducer(CATEGORY);
const ProfileGetCategoryReducer = createGetDataReducer(PROFILE_CATEGORY);
const AddCategoryReducer = createGetDataReducer(ADD_CATEGORY);

const ServicesReducer = createGetDataReducer(SERVICES);

const CompanyProfileReducer = createGetDataReducer(COMPANYPROFILESETUP);
const UpdateCompanyProfileReducer = createGetDataReducer(UPDATECOMPANYPROFILE);
const GetProfileReducer = createGetDataReducer(GETPROFILESETUP);
const ProfileDetailReducer = createGetDataReducer(PROFILEDETAIL);
const DetailProfileReducer = createGetDataReducer(DETAILPROFILE);
const UpdateProfileReducer = createGetDataReducer(UPDATEPROFILE);
const ResubmitProfileReducer = createGetDataReducer(RESUBMITPROFILE);
const RemoveProfileReducer = createGetDataReducer(REMOVEPROFILEIMAGE);
const HomePageCategoryReducer = createGetDataReducer(HOME_PAGE_GET_CATEGORY);


export const CompanyReducer = {
    CategoryState: CategoryReducer,
    ProfileGetCategoryState: ProfileGetCategoryReducer,
    AddCategoryState: AddCategoryReducer,

    ServicesState: ServicesReducer,
    CompanyProfileState: CompanyProfileReducer,
    UpdateCompanyProfieState: UpdateCompanyProfileReducer,
    GetProfileState: GetProfileReducer,
    ProfileDetailState: ProfileDetailReducer,
    DetailProfileState: DetailProfileReducer,
    UpdateProfileState: UpdateProfileReducer,
    ResubmitProfileState: ResubmitProfileReducer,
    RemoveProfileState: RemoveProfileReducer,
    HomePageCategoryState: HomePageCategoryReducer
}